import React from "react";
import { FaCog, FaLock } from "react-icons/fa";
import { renderCardIcon, skillIcon } from "../common/IconLibrary";

const SkillCard = ({ item, onClick }) => {
  // Sort tags: 'core' first (if present), then alphabetically
  const sortedTags = React.useMemo(() => {
    if (!item.tags) return [];
    const coreTag = item.tags.find((tag) => tag.toLowerCase() === "core");
    const otherTags = item.tags
      .filter((tag) => tag.toLowerCase() !== "core")
      .sort();
    return coreTag ? [coreTag, ...otherTags] : otherTags;
  }, [item.tags]);

  return (
    <div className={`card-glass`} onClick={onClick}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <span className="text-gray-300 mr-2">
            {renderCardIcon(skillIcon, 24)}
          </span>
          <h3 className="text-xl font-semibold text-gray-100">{item.key}</h3>
        </div>
        {item.core && <FaLock className="text-indigo-500" title="Core Skill" />}
      </div>
      <div className="relative group">
        <p className="text-gray-300 mb-4 h-12 line-clamp-2 overflow-hidden">
          {item.description}
        </p>
        <div className="hint-glass">{item.description}</div>
      </div>
      <div className="flex flex-col w-full text-gray-300 mb-4 h-16">
        <div
          className={`flex items-center mb-2 ${
            item.preProcessing ? "text-blue-400" : "text-gray-500"
          }`}
        >
          <FaCog className="mr-2" />
          <span className="text-sm">
            {item.preProcessing ? "Pre-Processing" : <s>Pre-Processing</s>}
          </span>
        </div>
        <div
          className={`flex items-center ${
            item.postProcessing ? "text-green-400" : "text-gray-500"
          }`}
        >
          <FaCog className="mr-2" />
          <span className="text-sm">
            {item.postProcessing ? "Post-Processing" : <s>Post-Processing</s>}
          </span>
        </div>
      </div>
      <div className="flex flex-wrap mb-0">
        {sortedTags.map((tag) => {
          if (!tag || tag.trim() === "") return null;
          const isCoreTag = tag.toLowerCase() === "core";
          return (
            <span
              key={tag}
              className={`text-white text-xs px-2 py-1 rounded-full mr-2 mb-2 ${
                isCoreTag ? "bg-indigo-600" : "bg-blue-500"
              }`}
            >
              {tag}
            </span>
          );
        })}
        <span
          key="this_tag_ensures_proper_spacing__do_not_remove"
          className={`text-xs px-2 py-1 rounded-full mr-2 mb-2 opacity-0`}
        >
          .
        </span>
      </div>
    </div>
  );
};

export default SkillCard;
